import { Accordion, Card, Col, EventHandler, InputField, Label, OutlineButton, PopupDialogbox, PrimaryButton, ReactSelectBox, Row, SwitchToggle, Tooltip } from "client/CommonComponents";
import LocationContainer from "./Location";
import "./Disposition.scss"
import { CONSTANTS } from "client/utils/constants";
import DispositionSubChoices from "./DispositionSubChoices";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import permissions, { isAuthorized } from "client/utils/Permissions";

const Disposition = (props: any) => {
    const {
        dispositionChoiceDropdownList,
        assetDisposition,
        onChangeDispositionChoice,
        onClickAddToCart,
        dispositionList,
        isCartUpdated,
        onCancelClick,
        Popupcontent,
        hideDialog,
        id,
        onClickReset,
        isDispositionAssetValid,
        isLocationAssetValid,
        setLocationAssetValid,
        isDispositionValidate,
        isEditOrder,
        transferOrderByIdData,
        cancelRequestOnClick,
        revertChangesOnClick,
        isRevertChanges,
        setIsRevertChanges,
        isDispositionAssetLocationValid,
        setIsDispositionChoiceChanged,
        isDispositionChoiceChenged,
        onClick,
        AssetDispostionFieldRef,
        onClickLocationContainer,
        isEnableLocation,
        warningHideDialog,
        WarningPopupcontent,
        onchangePenaltyExemptionReason,
        showExemptionFields,
        onchangeIsPenalityExemption,
        totalPenaltyFee,
        globalPenaltyFlag
    } = props

    const dispositionHeader = () => {
        return [{
            headerText: <>
                <div className="pull-left">
                    <p className={`accordion-heading ${isDispositionAssetLocationValid && !isCartUpdated ? 'not-added-to-cart' : 'added-to-cart'}`}>ASSET DISPOSITION</p>
                    <p className="subText">Provide disposition details and location</p>
                </div>
                <div className="right-heading-dispostion">
                    {isDispositionAssetValid ? <span className="error-reason me-2 mt-1 pull-right">Asset disposition is  required</span> : ''}
                </div>
            </>,
            content: <>
                <Row className="p-3">
                    <Col xs={12} md={4} lg={4} className='mb-3' >
                        <Label required data-attribute="Disposition_Default_Label">Disposition Choice</Label>
                        <EventHandler onEvent={(e: any) => onClick(e)} data-attribute="Disposition_Default_EventHandler">
                            <div>
                                <Tooltip content={assetDisposition?.dispositionChoice ? assetDisposition?.dispositionChoice?.text : ''} data-attribute="Disposition_Default_Tooltip">
                                    <ReactSelectBox
                                        options={dispositionChoiceDropdownList}
                                        onChange={onChangeDispositionChoice}
                                        value={assetDisposition?.dispositionChoice?.value ? assetDisposition?.dispositionChoice : ''}
                                        placeholder={'Select'}
                                        isSearchable={true}
                                        selectRef={(element: any) => AssetDispostionFieldRef.current[0] = element}
                                        className={dispositionList?.assetDispositionChoiceError?.length ? 'controlValidation' : ''}
                                     data-attribute="Disposition_Default_SearchSelectBox" />
                                </Tooltip>
                                {dispositionList?.assetDispositionChoiceError ? <p className='validMessage'>{dispositionList?.assetDispositionChoiceError}</p> : ""}
                                {dispositionList?.assetDispositionChoiseAttatmentNote ? <p className='note-diposition-msg pull-left'><span>Note - </span>{dispositionList?.assetDispositionChoiseAttatmentNote}</p> : ""}
                            </div>
                        </EventHandler>
                    </Col>
                    {(assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY
                        || assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY
                        || assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED
                        || assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED) &&
                        <DispositionSubChoices
                            isDispositionValidate={isDispositionValidate}
                            isRevertChanges={isRevertChanges}
                            setIsRevertChanges={setIsRevertChanges}
                            setIsDispositionChoiceChanged={setIsDispositionChoiceChanged}
                            isDispositionChoiceChenged={isDispositionChoiceChenged}
                            AssetDispostionFieldRef={AssetDispostionFieldRef}
                        />
                    }
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        {dispositionList?.assetReplacementFleetAssetError ? <p className='validMessage'>{dispositionList?.assetReplacementFleetAssetError}</p> : ""}
                        {showExemptionFields ? <div className='write-off-block'>
                            {totalPenaltyFee > 0 ?
                                <>
                                    <p className="write-off-penalty-toggle mt-3"><span>Request Write Off Penalty Exemption</span><SwitchToggle className='mb-0' checked={dispositionList?.isWriteOffPenaltyExemption} onChange={(e?: any, item?: any) => { onchangeIsPenalityExemption(e, item) }}  data-attribute="Disposition_Default_SwitchToggle" /></p>
                                </> : null}
                        </div> : ''}
                    </Col>
                    {
                        showExemptionFields ? <>  <Col xs={12} md={12} lg={12} className='write-off-block'>
                            {dispositionList?.isWriteOffPenaltyExemption && globalPenaltyFlag ?
                                <>
                                    <Label required data-attribute="Disposition_Default_Label_2">Penalty Exemption Reason</Label>
                                    <InputField multiline={true} resizable={false} value={dispositionList?.assetDispositionPenaltyExemptionReason ?? ""} className={dispositionList?.assetDispositionPenaltyExemptionReasonError?.length ? 'controlValidation comment-block' : 'comment-block'} onChange={onchangePenaltyExemptionReason}  data-attribute="Disposition_Default_Input" />
                                </>
                                : null}</Col>
                            {dispositionList?.isWriteOffPenaltyExemption ?
                                <>
                                    {dispositionList?.assetDispositionPenaltyExemptionReasonError?.trim().length ? <p className='validMessage'>{dispositionList?.assetDispositionPenaltyExemptionReasonError}</p> : ""}
                                </>
                                : null}
                        </>
                            : ''
                    }
                </Row>
            </>,
            uuid: 'Asset_1'

        }]
    }

    const expandedItems1: any = [...dispositionHeader()]

    const expandedItems = [
        ...dispositionHeader(),
        {
            headerText:
                <EventHandler onEvent={onClickLocationContainer} data-attribute="Disposition_Default_EventHandler_2">
                    <div className="location-header">
                        <div className="pull-left">
                            <p className={`accordion-heading ${isDispositionAssetLocationValid && !isCartUpdated ? 'not-added-to-cart' : 'added-to-cart'}`}>ASSET LOCATION</p>
                            <p className="subText ">If the asset has been towed or is at another location other than the branch</p>
                        </div>
                        <div className="right-heading-dispostion">
                            {isLocationAssetValid ? <span className="error-reason me-2 mt-sm-1 mt-2 pull-right">Asset location is  required</span> : ''}
                        </div>
                    </div>
                </EventHandler>,
            content: <>
                <LocationContainer
                    setLocationAssetValid={setLocationAssetValid}
                    isRevertChanges={isRevertChanges}
                    setIsRevertChanges={setIsRevertChanges}
                    // DispositionLocationFieldRef={DispositionLocationFieldRef}
                    AssetDispostionFieldRef={AssetDispostionFieldRef}
                />
            </>,
            uuid: 'Asset_2'
        }
    ];
    return (
        <>
            <Card data-attribute="Disposition_Default_Card">
                {
                    isEnableLocation ?
                        <Accordion
                            Items={expandedItems}
                            preExpanded={['Asset_1']}
                            allowMultipleExpanded={false}
                            className={'Asset-disposition-location-accordion'}
                            onChange={onClickLocationContainer}
                         data-attribute="Disposition_Default_Accordion" /> : <>
                            <Accordion
                                Items={expandedItems1}
                                preExpanded={['Asset_1']}
                                allowMultipleExpanded={false}
                                className={'Asset-disposition-location-accordion'}
                                onChange={onClickLocationContainer}
                             data-attribute="Disposition_Default_Accordion_2" />
                            <div className={`pull-left Asset-Location-NA ${isDispositionAssetLocationValid && !isCartUpdated ? 'not-added-to-cart' : 'added-to-cart'}`}>
                                <p className={`accordion-heading`}>ASSET LOCATION <span><b> - N/A</b></span></p>
                            </div>
                        </>
                }

                <Row className='mb-1'>
                    <Col xs={12} sm={12} md={12} lg={12} className='mt-0'>

                        <a className='me-0 reset-btn-disposition' href='/' onClick={(e: any) => onClickReset(e)}>Reset</a>

                        <div className='pull-right transfer-asset-content'>
                            <div className='cancel-edit-btn reactivation mb-sm-0 mb-2'>
                                {
                                    (isEditOrder || transferOrderByIdData?.orderStatus?.includes('Pending Approval')) && <PrimaryButton className='ml-2' text='Revert Changes' onClick={() => { revertChangesOnClick() }}  disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Disposition_Default_Button" />
                                }
                                {
                                    (isEditOrder || transferOrderByIdData?.orderStatus?.includes('Pending Approval')) && <OutlineButton text='Cancel Request' onClick={() => { cancelRequestOnClick() }}  disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Disposition_Default_Button_2" />
                                }
                            </div>
                            {id ? '' : <OutlineButton text='Cancel' onClick={onCancelClick}  disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Disposition_Default_Button_3" />}
                            <PrimaryButton text={isCartUpdated ? 'Update to Cart' : 'Add to Cart'} onClick={onClickAddToCart}  disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Disposition_Default_Button_4" />
                        </div>
                    </Col>
                </Row>
            </Card>

            {Popupcontent.isDialogVisible ?
                <PopupDialogbox
                    hideDialog={!Popupcontent.isDialogVisible}
                    onDismiss={hideDialog}
                    Popupcontent={Popupcontent}
                    popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
                    popupPrimarybtnOnclick={(
                        item: any,
                        actionby: string,
                        value: any
                    ) => {
                        Popupcontent?.popupPrimarybtnOnclick(
                            item,
                            actionby,
                            value
                        );
                    }}
                 data-attribute="Disposition_Default_PopupDilalogBox" /> : ""}
            {WarningPopupcontent.isDialogVisible ?
                <CancelConfirmationPopup
                    hideDialog={!WarningPopupcontent.isDialogVisible}
                    onDismiss={warningHideDialog}
                    Popupcontent={WarningPopupcontent}
                    popupOutlinebtnOnclick={() => WarningPopupcontent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={() => WarningPopupcontent.popupPrimarybtnOnclick()}
                    className='penalty-warning-popup'
                /> : ""}
        </>
    )
}

export default Disposition
